import React from 'react';
import ErrorMessage from '../components/ErrorMessage';

const AppointmentDetails = ({ appointment, error }) => {
    let wazeIcon = null;
    if (appointment?.clinicAddress) {
        wazeIcon = <a href={appointment?.wazeUrl}>
            <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.41218 2.30802C0.578183 5.39002 3.19485 9.40935 0.840182 9.40935C0.146182 9.40935 -0.244484 10.2154 0.169516 10.7747C0.908183 11.7714 1.84018 12.4334 2.83752 12.8734C3.67952 10.398 7.31485 11.1147 7.19018 13.7127C7.42685 13.7187 8.25218 13.7194 8.48952 13.7187C8.43152 12.4107 9.44752 11.342 10.7288 11.342C11.6255 11.342 12.4435 11.9 12.7895 12.7367C14.0742 11.9627 15.1948 10.716 15.6728 9.24069C17.7275 2.91535 9.84552 -2.05265 4.41218 2.30802ZM10.6608 4.82202C11.1068 4.82202 11.4668 5.18869 11.4668 5.64202C11.4668 6.09335 11.1062 6.46002 10.6608 6.46002C10.2168 6.46002 9.85485 6.09335 9.85485 5.64202C9.85485 5.18802 10.2168 4.82202 10.6608 4.82202ZM6.81418 4.95002C7.25818 4.95002 7.62018 5.31669 7.62018 5.76802C7.62018 6.22135 7.25818 6.58802 6.81418 6.58802C6.37018 6.58802 6.00818 6.22135 6.00818 5.76802C6.00818 5.31669 6.37018 4.95002 6.81418 4.95002ZM11.6848 8.10468C11.4375 9.16069 10.3508 10.1187 8.83352 10.1594C7.52152 10.248 6.05952 9.24735 5.90952 7.91335C5.84285 7.35335 6.67885 7.25602 6.74152 7.81535C6.84352 8.72402 7.91152 9.33202 8.81085 9.30735C9.95485 9.27735 10.7108 8.58002 10.8668 7.90802C10.9208 7.67935 11.1455 7.53802 11.3722 7.59068C11.5975 7.64535 11.7368 7.87402 11.6848 8.10468Z" fill="#40B8E9" />
            </svg>
        </a>;
    }

    return (
        <div id="appointment_details" className="container">
            <div className="appointmentDetails_title">{appointment?.appointmentDetailsTitle}</div>
            <ErrorMessage show={error} text={"תקלה טכנית. אפשר לנסות שוב מאוחר יותר"} />
            <table className="table table-bordered">
                <tbody>
                    <tr className="d-flex">
                        <th scope="col" className="d-flex text-center col-3 align-items-center justify-content-center">תאריך</th>
                        <td className="d-flex text-center col-9 align-items-center">{appointment?.day}, {appointment?.date}</td>
                    </tr>
                    <tr className="d-flex">
                        <th scope="col" className="d-flex text-center col-3 align-items-center justify-content-center">שעה</th>
                        <td className="d-flex text-center col-9 align-items-center">{appointment?.time}</td>
                    </tr>
                    {appointment?.clinicAddress ?
                        <tr className="d-flex">
                            <th scope="col" className="d-flex text-center col-3 align-items-center justify-content-center">כתובת</th>
                            <td className="d-flex flex-column col-9 justify-content-center">
                                <div className="ms-1">{appointment?.clinicAddress}</div>
                                <div>
                                    {wazeIcon}
                                    <span className="me-1 waze-link">פתח ב-Waze</span>
                                </div>
                            </td>
                        </tr> :
                        null}
                </tbody>
            </table>
            {appointment && appointment.additionalText ? <div className="appointmentDetails_additionalText">{appointment.additionalText}</div> : null}
        </div>
    );
}

export default AppointmentDetails;